// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"246":"1a72fce291e3cf1131d8","4529":"cc9dd54cf3388e0b656a"}[chunkId] + ".css";
};